import { render } from "./PurchaseOrderDetails.vue?vue&type=template&id=6351d2f4"
import script from "./PurchaseOrderDetails.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__